import { groupConstants as gc } from 'srcReact/GroupPage'
import { objectMap, commonProperties } from 'srcReact/helpers/utils'

const initialState = {
  addPost: {
    loading: false,
    success: false,
    error: ''
  }
}

export function group(state = initialState, action) {
  switch (action.type) {
    // Send invites
    case gc.SEND_INVITES_REQUEST:
      return {
        ...state,
        invitation: { sending: true, sent: false, error: false }
      }
    case gc.SEND_INVITES_SUCCESS:
      return {
        ...state,
        invitation: {
          sending: false,
          sent: true,
          error: false
        }
      }
    case gc.SEND_INVITES_FAILURE:
      return {
        ...state,
        invitation: { sending: false, sent: false, error: true }
      }
    // add comment
    case gc.ADD_COMMENT_REQUEST:
      return {
        ...state,
        addPost: {
          ...state.addPost,
          loading: true
        }
      }
    case gc.ADD_COMMENT_SUCCESS:
      return {
        ...state,
        addPost: {
          ...state.addPost,
          loading: false,
          success: true
        }
      }
    case gc.ADD_COMMENT_FAILURE:
      return {
        ...state,
        addPost: {
          ...state.addPost,
          loading: false,
          success: false,
          error: action.error
        }
      }
    case gc.CLEAR_COMMENT_STATE: {
      return {
        ...state,
        addPost: initialState.addPost
      }
    }
    default:
      return state
  }
}
